// Core
import React, { useState, useEffect } from "react"
import { isMobile } from "react-device-detect"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"
import PlayBtn from "./../playBtn"

// Style
import styles from "./videoGallery.module.scss"

// Images
import poster1 from "./images/poster1.jpg"
import poster2 from "./images/poster2.jpg"
import poster3 from "./images/poster3.jpg"

const VideoGallery = ({ count, scrollEvent, contentful_id, menuTitle }) => {
  const [active, setActive] = useState(0)

  const anchorOverride = menuTitle
    ? menuTitle.replace(/\s+/g, "-").toLowerCase()
    : null

  const videoData = [
    {
      vimeoID: "452169777",
      poster: poster1,
      title: "Residente with Gustavo Dudamel & the LA Phil",
    },
    {
      vimeoID: "452169777",
      poster: poster2,
      title: "J'Nai Bridges sings Florence Price",
    },
    {
      vimeoID: "452169777",
      poster: poster3,
      title: 'The Ford: Las Cafeteras - "La Bamba Rebelde"',
    },
  ]

  useEffect(() => {
    setTimeout(() => {
      if (!isMobile && scrollEvent) {
        window.scroll.on("call", (value, way, obj) => {
          if (value === "videos-" + contentful_id) scrollEvent(way, count, obj)
        })
      }
    }, 200)
  }, [])

  return (
    <ScrollSection>
      <div
        id={`ep-${anchorOverride ? anchorOverride : "extras"}`}
        className={`${styles.wrap} container`}
        data-scroll
        data-scroll-call={`videos-${contentful_id}`}
        data-scroll-offset="45%, 45%"
      >
        <div className={`cols`}>
          <div className={`${styles.videoCol} col m12 t6 d6`}>
            <div className={styles.videoWrap}>
              <PlayBtn event={null} />
              {videoData.map((data, index) => {
                return (
                  <img
                    key={`video-gallery-poster-${index}`}
                    src={data.poster}
                    className={`${styles.poster} ${
                      active === index ? styles.active : ""
                    }`}
                    width={888}
                    height={500}
                    alt={data.title}
                  />
                )
              })}
            </div>
          </div>
          <div className={`${styles.listCol} col m12 t5 d3`}>
            <div className={styles.list} data-scroll data-scroll-speed=".5">
              <p className={`mono`}>Supporting acts</p>
              <ul>
                {videoData.map((data, index) => {
                  return (
                    <li
                      key={`video-gallery-item-${index}`}
                      className={`h6 ${styles.title} ${
                        active === index ? styles.active : ""
                      }`}
                      onClick={setActive.bind(this, index)}
                    >
                      <span>{data.title}</span>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ScrollSection>
  )
}

export default VideoGallery
